import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { WelcomeMessagesQuery } from './WelcomeMessagesQuery.graphql.ts';

export function preloadWelcomeMessages() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: WelcomeMessagesQuery,
	});
}
